import { useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/useAuth';
import { makeApi } from '../api/client';
import { InviteMemberDialog } from '../components/InviteMemberDialog';
import { useToast } from '@dhuttu/ui';
import type { InviteInput } from './members.schema';

export default function MembersRoute() {
  const { getAccessToken } = useAuth();
  const api = makeApi(getAccessToken);
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  // GET /org/members doesn't exist in slice 1 spec — show current membership from /org/me
  const meQ = useQuery({
    queryKey: ['org', 'me'],
    queryFn: async () => (await api.org.me()).data,
  });
  const invite = useMutation({
    mutationFn: (d: InviteInput) => api.org.inviteMember({ body: { email: d.email, role: d.role } }),
    onSuccess: () => { setOpen(false); toast({ kind: 'success', title: 'Invitation sent' }); },
  });
  const membership = meQ.data?.membership;
  return (
    <section>
      <header className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-primary">Members</h1>
        <button onClick={() => setOpen(true)} className="rounded bg-primary px-4 py-2 text-white">Invite member</button>
      </header>
      <p className="text-sm text-ink/60 mb-4">Note: member list not available in this version. Showing your membership.</p>
      {membership && (
        <ul>
          <li className="border-b py-2 flex justify-between">
            <span>{membership.email} — {membership.role} — {membership.status}</span>
          </li>
        </ul>
      )}
      <InviteMemberDialog open={open} onClose={() => setOpen(false)} onSubmit={(d) => invite.mutate(d)} />
    </section>
  );
}
